module.exports = __webpack_public_path__ + "img/frame_contenuti_nologo.0f5e53b9.png";